import React, { useEffect } from 'react';
import { EspaceAtna } from '../components/espace/EspaceAtna';
import { ForYouFeed } from '../components/espace/ForYouFeed';
import { LocalNews, NearbyEvents, UsefulServices } from '../components/espace/LocalContent';
import { AppPromo } from '../components/espace/AppPromo';
import { citizenFirstName } from '../data/espace';
import { useEspace } from '../contexts/EspaceContext';
export function MonEspace() {
  const {
    enterEspace
  } = useEspace();
  useEffect(() => {
    enterEspace();
  }, [enterEspace]);
  return <main className="min-h-screen bg-white" data-id="element-2227" data-mp="12900q8qhboqr">
      <div className="px-5 py-10 lg:px-10" data-id="element-2228" data-mp="nc9aoq2p3pdt">
        <header data-id="element-2229" data-mp="nbfz9bsskbpc">
          <h1 className="text-3xl font-extrabold tracking-tight text-ville-navy lg:text-4xl" data-id="element-2230" data-mp="nbzkb1dqng7l">
            Bonjour {citizenFirstName}
          </h1>
          <p className="mt-1 text-[17px] text-slate-600" data-id="element-2231" data-mp="381yp51zhl95z">Voici ce qui vous concerne aujourd’hui.</p>
        </header>

        <div className="mt-6 max-w-3xl" data-id="element-2232" data-mp="3d1tcwwnytimt">
          <EspaceAtna data-id="element-2233" data-mp="3czgn5xbyu3z7" />
        </div>

        <ForYouFeed data-id="element-2234" data-mp="1ax39nt8amqpi" />
        <LocalNews data-id="element-2235" data-mp="1aympjiq1ezqr" />
        <NearbyEvents data-id="element-2236" data-mp="1ay4w0turezmj" />
        <UsefulServices data-id="element-2237" data-mp="1azg250bogjgt" />
        <AppPromo data-id="element-2238" data-mp="15ys3bsh7iyc1" />
      </div>
    </main>;
}